import React from 'react';

import './Card22.css';

const Card22 = props => {
  return (
    <div className={`card22 ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card22;
